import { render } from './src/render/render';

fbErrorsService.$inject = ['$translate'];

export default function fbErrorsService($translate) {
  const cache = {};
  const LOCALE = translate();
  //
  return {
    /**
     * Se crea el validator en ecFormBuilderService.Validator
     * Llamado desde
     * -> fb-errors/Validator.class validate.runValidate
     *
     * @param {string} workerUrl
     * @returns
     */
    validate: workerUrl => {
      return (schema, data, options) => {
        return getValidateWorker(workerUrl).then(validateWorkerFn => {
          // console.log('fbErrorsService', { schema, data, options });
          return validateWorkerFn({ schema, data, options });
        });
      };
    },
    render: errors => {
      const html = render(errors, LOCALE);
      return Promise.resolve(html);
    },
  };

  function getValidateWorker(workerUrl) {
    if (cache.validateWorkerFn) {
      return Promise.resolve(cache.validateWorkerFn);
    }

    return fetch(workerUrl)
      .then(response => response.text())
      .then(script => {
        cache.validateWorkerFn = edicom.worker.parse(`${script};return ecFormBuilderEdicomWorker.validate({ schema, data, options });`);
        return cache.validateWorkerFn;
      });
  }

  function translate() {
    const errors = ['required', 'min', 'max', 'step', 'email', 'pattern', 'minLength', 'maxLength', 'decimal', 'number', 'date', 'search', 'fiscalnumber'];
    const LOCALE = {};
    errors.forEach(error => (LOCALE[error] = $translate.instant(`ecErrorMessages.${error}`)));
    return LOCALE;
  }
}
